<div class="search-settings" [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar top" [attr.data-automation-id]="automationId + '-header'">
        <button type="button" automation-id="'search-setting-save-button'" class="primary-button"
            (click)="saveChanges()" [disabled]="!isDirty || isBusy" *ngIf="hasPermissions">Save</button>
        <button type="button" [attr.data-automation-id]="automationId + '-discard-changes-button'"
            class="secondary-button" (click)="discardChanges()" [disabled]="!isDirty || isBusy"
            *ngIf="hasPermissions">Discard Changes</button>
        <button type="button" class="help-button" automation-id="'search-setting-help-button'" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <form class="content" #contentForm="ngForm" [attr.data-automation-id]="automationId + '-content'"
        [resBusySpinner]="isBusy" [message]="isBusyMessage">
        <div class="left-settings-panel">
            <div class="parent-header">
                <div class="modal-row">
                    <div class="longLabel">
                         <label [ngClass]="{'disabled': !hasPermissions}">Search Syntax: Standard</label>
                    </div>
                </div>
                <div class="modal-row" *ngIf="isProjectSettings">
                    <div class="longLabel">
                        <label [ngClass]="{'disabled': !hasPermissions}">Tokenization Version:
                            {{tokenizationVersion}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-settings-panel">
            <div class="parent-header">
                <div class="settings-panel-header">Search Term Report</div>
                <div class="modal-row">
                    <div class="modal-row-column-auto">
                        <label [ngClass]="{'disabled': !hasPermissions}">Downloaded Report Options (.xlsx):</label>
                    </div>
                    <div class="modal-row-column-auto">
                        <res-custom-checkbox name="INC_PERCUSTODIAN_SHEETS"
                            automationId="search-settings-include-per-custodian-sheets" [disabled]="!hasPermissions"
                            [(ngModel)]="viewModel.model.includeCustodianSheets" content="Include Per-Custodian Sheets"
                            (ngModelChange)="onChange()"></res-custom-checkbox>
                        <res-custom-checkbox name="INC_PERBATCH_SHEETS"
                            automationId="search-settings-include-per-batch-sheets" [disabled]="!hasPermissions"
                            [(ngModel)]="viewModel.model.includeBatchSheets" content="Include Per-Batch Sheets"
                            (ngModelChange)="onChange()"></res-custom-checkbox>
                    </div>
                </div>
            </div>
            <div class="list-container">
                <div class="list-header">
                    <div class="column-number">
                        <span>Column Number</span>
                    </div>
                    <div class="column-name">
                        <span>Column Name</span>
                    </div>
                    <div class="custom-name">
                        <span>Custom Name</span>
                    </div>
                    <div class="include-in-report">
                        <span>Include in Report</span>
                    </div>
                </div>
                <div class="list-content" style=" border: none">
                    <div *ngFor='let entry of searchTermMetricsFields; index as i; trackBy:trackByFunction'
                        [attr.data-automation-id]="'search-term-metric-list-item-' + i">
                        <div class="list-item">
                            <div class="row-container">
                                <div class="column-number-data">
                                    <span [title]="entry.index"
                                        [attr.data-automation-id]="'search-settings-id-grid-cell-drag-button' + i"
                                        [ngClass]="{'disabled': !hasPermissions}">{{entry.index}}</span>
                                </div>
                                <div class="drag-container">
                                    <div class="list-drag-item-empty-drop-zone-holder" dndDropzone
                                        (dndDrop)="onFieldDrop($event, entry)">
                                        <div class="list-drag-item empty-drop-zone"
                                            [ngClass]="{'disabled': !hasPermissions}"
                                            [attr.data-automation-id]="'empty-drop-zone'">
                                        </div>
                                        <div class="list-drag-item" [ngClass]="{'disabled': !hasPermissions}"
                                            [dndDraggable]="entry" [dndDisabledIf]="!hasPermissions">
                                            <div class="drag-row-container">
                                                <div class="column-name-data">
                                                    <img class="drag-dots" *ngIf="hasPermissions"
                                                        src="assets/images/drag_grey.png">
                                                    <span [title]="entry.defaultLabel" class="min-cell-height"
                                                        [attr.data-automation-id]="'search-settings-id-column-name-' + i"
                                                        [ngClass]="{'disabled': !hasPermissions}">{{entry.defaultLabel}}</span>
                                                </div>
                                                <div class="custom-name-data">
                                                    <div class="user-field min-cell-height">
                                                        <input type="text" [(ngModel)]="entry.label"
                                                            name="entry.label{{i}}"
                                                            [attr.data-automation-id]="'search-settings-custom-name-input-' + i"
                                                            (ngModelChange)="onCustomLabelChange()"
                                                            [disabled]="!hasPermissions"
                                                            [maxLength]="maxCustomNameLength">
                                                    </div>
                                                </div>
                                                <div class="checkbox-column">
                                                    <res-custom-checkbox
                                                        [automationId]="'search-settings-custom-name-input' + '-' + i"
                                                        [(ngModel)]="entry.enabled"
                                                        [disabled]="entry.editEnable || !hasPermissions"
                                                        name="entry.enabled{{i}}" [labelPaddingLeft]="10"
                                                        [labelPaddingRight]="7" (ngModelChange)="onChange()">
                                                    </res-custom-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="empty-list-item" *ngIf="hasPermissions"
                        [attr.data-automation-id]="automationId + '-empty-drop-zone-container'">
                        <div class="empty-number-data"></div>
                        <div class="empty-drop-zone" dndDropzone (dndDrop)="onFieldDrop($event, 'dropOnLastPosition')"
                            [attr.data-automation-id]="automationId + '-empty-drop-zone'">
                            <span>Drop here ...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
